export default [
  { key: 'successful', val: 'Successful' },
  { key: 'in_progress', val: 'In Progress' },
  { key: 'completed_with_errors', val: 'Completed with Errors' },
  { key: 'failed', val: 'Failed' },
  { key: 'in_progress,completed_with_errors,failed', val: 'All Outstanding' }
];
